module.exports = __webpack_public_path__ + "img/AFMS_OVERTEMP.abee8f07.png";